import { useMenusBiLogger } from 'root/hooks/useMenusBiLogger';
import { ImageAction } from 'root/consts';

export const useImageBi = () => {
  const { reportItemImageAction } = useMenusBiLogger();

  return {
    onExpand: () => {
      reportItemImageAction({ action: ImageAction.EXPAND_IMAGE });
    },
    onNext: () => {
      reportItemImageAction({ action: ImageAction.CLICK_RIGHT });
    },
    onPrevious: () => {
      reportItemImageAction({ action: ImageAction.CLICK_LEFT });
    },
    onClose: () => {
      reportItemImageAction({ action: ImageAction.CLOSE });
    },
  };
};
